"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingGoModVersionDirectiveError = void 0;
class MissingGoModVersionDirectiveError extends Error {
    constructor(...args) {
        super(...args);
        this.code = 422;
        this.name = 'MissingGoModVersionDirectiveError';
        Error.captureStackTrace(this, MissingGoModVersionDirectiveError);
    }
}
exports.MissingGoModVersionDirectiveError = MissingGoModVersionDirectiveError;
//# sourceMappingURL=missing-go-mod-version-directive-error.js.map